// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-users-container {
  height: 70vh;
}

.marketplace-dropdown-container .marketplaces-dropdown {
  margin: 0 auto;
  height: 80vh;
}
.marketplace-dropdown-container .marketplaces-dropdown.basic-single {
  min-width: 400px;
  height: 40px;
}
.marketplace-dropdown-container .marketplaces-dropdown.basic-single .select__control {
  min-height: 50px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Users/Users.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEE;EACE,cAAA;EACA,YAAA;AACJ;AAAI;EACE,gBAAA;EACA,YAAA;AAEN;AADM;EACE,2BAAA;AAGR","sourcesContent":[".all-users-container {\n  height: 70vh;\n}\n.marketplace-dropdown-container {\n  .marketplaces-dropdown {\n    margin: 0 auto;\n    height: 80vh;\n    &.basic-single {\n      min-width: 400px;\n      height: 40px;\n      .select__control {\n        min-height: 50px !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
